import React, { useEffect, useCallback } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { Box, CircularProgress } from "@mui/material"
import i18n from "i18n"

import { useAuthContext } from "context/auth/authContext"
import {
  useOrganizationPurchaseOrders,
  useProjectPurchaseOrders,
} from "./hooks/usePurchaseOrders"
import PurchaseOrdersHeader from "./Dashboard/Header"
import PurchaseOrdersDataGrid from "./Dashboard/PurchaseOrdersDataGrid"
import EmptyState from "common/EmptyState"

const PurchaseOrders = () => {
  const { projectId } = useParams()
  const navigate = useNavigate()
  const { user } = useAuthContext()
  const organizationId = user?.["custom:organizationId"]
  const isProjectRoute = !!projectId

  const projectPurchaseOrdersQuery = useProjectPurchaseOrders(
    organizationId,
    projectId,
    isProjectRoute && !!organizationId,
  )
  const organizationPurchaseOrdersQuery = useOrganizationPurchaseOrders(
    organizationId,
    !isProjectRoute && !!organizationId,
  )

  const {
    data: purchaseOrders = [],
    isLoading,
    error,
  } = isProjectRoute
    ? projectPurchaseOrdersQuery
    : organizationPurchaseOrdersQuery

  const handleAddNewPurchaseOrder = useCallback(() => {
    navigate(
      projectId ? `/purchase-order/new/${projectId}` : "/purchase-order/new",
    )
  }, [navigate, projectId])

  if (!user) return null

  return (
    <Box>
      <PurchaseOrdersHeader onAddNewPurchaseOrder={handleAddNewPurchaseOrder} />

      {isLoading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "120px",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {error && <div>{i18n.t("purchaseOrders.errorLoading")}</div>}
      {Array.isArray(purchaseOrders) &&
        purchaseOrders.length === 0 &&
        !isLoading && (
          <EmptyState
            title={i18n.t("purchaseOrders.noItemsYet")}
            buttonText={i18n.t("purchaseOrders.newPurchaseOrder")}
            onButtonClick={handleAddNewPurchaseOrder}
          />
        )}
      {Array.isArray(purchaseOrders) && purchaseOrders.length > 0 && (
        <PurchaseOrdersDataGrid purchaseOrders={purchaseOrders} />
      )}
    </Box>
  )
}

export default PurchaseOrders
